// /src/components/modals/ImovelEditorModal/EditorConstants.js

export const OPCOES_NEGOCIO = [
    { value: 'Linhas novas', label: 'Linhas novas' }, 
    { value: 'Portabilidade', label: 'Portabilidade' }, 
    { value: 'Renegociação 1', label: 'Renegociação 1' },
    { value: 'Renegociação 2', label: 'Renegociação 2' },
    { value: 'Transferência CPF para CNPJ', label: 'Transferência de titularidade CPF para CNPJ' },
    { value: 'Transferência Pre para Pós', label: 'Transferência Pre TIM para Pós' },
    { value: 'TIM FIBRA', label: 'TIM UltraFibra' },
    { value: 'M2M / IOT', label: 'M2M / IoT / Telemetria' },
    { value: 'Upgrade de Plano', label: 'Upgrade / Upgrade Turbo' }
];

export const OPCOES_PRINCIPAL = [
    { value: 'CPF', label: 'CPF' }, 
    { value: 'CNPJ', label: 'CNPJ' }, 
    { value: 'Ambos', label: 'Ambos' }
];

export const SUBTIPOS_ENTREGA = [
    'Correio', 'Sedex', 'Transportadora TIM', 
    'Retirada', 'Motoboy', 'Ativação Digital (eSim)', 
    'Instalação Técnica'
];

export const PROMOCOES_ELITE = [
    { value: 'promocional', label: 'Promocional' },
    { value: 'melhor_custo_beneficio', label: 'Melhor Custo Benefício' },
    { value: 'mais_vendido', label: 'Mais Vendido' },
    { value: 'exclusivo_cnpj', label: 'Exclusivo CNPJ' }
];